import { useTranslation } from 'react-i18next';
import { AppLanguage } from '@anytag/shared-types';
import { cn, localizedDateFormatter } from '@anytag/shared-utils';
import { Maybe } from '@anytag/graphql';
import { LinkifyItPreview } from '@anytag/shared-molecules';

interface RequestModificationMessageProps {
  date?: string;
  className?: string;
  message?: Maybe<string>;
}

export const RequestModificationMessage = ({ className, date = '', message }: RequestModificationMessageProps) => {
  const { t, i18n } = useTranslation();

  return message ? (
    <div className={cn('mt-4 bg-black-10 p-4', className)}>
      <div className="flex items-center justify-between">
        <p>{t('Request message')}:</p>
        {date ? <p>{localizedDateFormatter(date, 'PPP', i18n.language as AppLanguage)}</p> : null}
      </div>
      <LinkifyItPreview value={message} className="mt-2 max-h-75 bg-black-10" />
    </div>
  ) : null;
};
